/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCustomQuestionMutationVariables = Types.Exact<{
  questionId: Types.Scalars['Int'];
}>;


export type DeleteCustomQuestionMutation = { deleteCustomQuestion?: boolean | undefined };


export const DeleteCustomQuestionDocument = gql`
    mutation DeleteCustomQuestion($questionId: Int!) {
  deleteCustomQuestion(questionId: $questionId)
}
    `;

/**
 * __useDeleteCustomQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteCustomQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomQuestionMutation, { data, loading, error }] = useDeleteCustomQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useDeleteCustomQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomQuestionMutation, DeleteCustomQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomQuestionMutation, DeleteCustomQuestionMutationVariables>(DeleteCustomQuestionDocument, options);
      }
export type DeleteCustomQuestionMutationHookResult = ReturnType<typeof useDeleteCustomQuestionMutation>;
export type DeleteCustomQuestionMutationResult = Apollo.MutationResult<DeleteCustomQuestionMutation>;
export type DeleteCustomQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteCustomQuestionMutation, DeleteCustomQuestionMutationVariables>;